/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { assistantsGet } from "../funcs/assistantsGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Assistant } from "../models/components/assistant.js";
import {
  GetAssistantRequest,
  GetAssistantSecurity,
} from "../models/operations/getassistant.js";
import { unwrapAsync } from "../types/fp.js";
export type AssistantsGetQueryData = Assistant;

export function prefetchAssistantsGet(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetAssistantRequest,
  security?: GetAssistantSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAssistantsGetQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAssistantsGetQuery(
  client$: GramCore,
  request: GetAssistantRequest,
  security?: GetAssistantSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<AssistantsGetQueryData>;
} {
  return {
    queryKey: queryKeyAssistantsGet({
      id: request.id,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function assistantsGetQueryFn(
      ctx,
    ): Promise<AssistantsGetQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(assistantsGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAssistantsGet(
  parameters: {
    id: string;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "assistants", "get", parameters];
}
